import { render, staticRenderFns } from "./OrderAddressDetailForm.vue?vue&type=template&id=47108cfc&"
import script from "./OrderAddressDetailForm.vue?vue&type=script&lang=js&"
export * from "./OrderAddressDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports